import axios, { CancelTokenSource } from "axios";
import api, { ApiResponse } from "./../api";
import { FailedImageHistoryTableInfoModel, FailedImageLogsFilterModel, FailedImageLogsItemModel } from "./failedImageLogsModels";
export const REQUEST_ID: {
    [key: string]: string;
} = {
    GET_RECORDS: "get_failed_image_logs"
};

class FailedImageLogsService {
    private source: {
        [key: string]: CancelTokenSource;
    };

    private static instance: FailedImageLogsService;

    private constructor() {
        this.source = {};
    };

    static getInstance(): FailedImageLogsService {
        if (!FailedImageLogsService.instance) {
            FailedImageLogsService.instance = new FailedImageLogsService();
        }
        return FailedImageLogsService.instance;
    };

    public getFailedImageLogsRecords = async (
        filter: FailedImageLogsFilterModel,
        page: number
    ): Promise<ApiResponse<FailedImageLogsItemModel>> => {
        this.source[REQUEST_ID.GET_RECORDS] && this.source[REQUEST_ID.GET_RECORDS].cancel();
        this.source[REQUEST_ID.GET_RECORDS] = axios.CancelToken.source();
        return await api.post(
            "failed-image-logs/failedimages",
            { ...filter, page }, // Send the payload in the request body
            {
                cancelToken: this.source[REQUEST_ID.GET_RECORDS].token,
            }
        );
    };

    public getFailedImageHistoryTableInfo = async (): Promise<ApiResponse<FailedImageHistoryTableInfoModel>> => {
        return await api.get("dotnet-programs-logs/tableinfo?type=failed");
    };
};

export default FailedImageLogsService;
